import {
  createShouldForwardProp,
  props as defaultStyledSystemProps,
} from '@styled-system/should-forward-prop'

export const ignorePropsForwarding = (...props: string[]) =>
  createShouldForwardProp([...defaultStyledSystemProps, ...props])
